import { useFormikContext } from "formik";
import moment from "moment";
import React from "react";

import { CurrentFinanceYear } from "../../../../config/app-constants";
import { IVirtualDigitalAssets } from "../../../../config/interfaces";
import { UtilService } from "../../../../services";
import { DateTimePicker, FormField, NumericInputField, TextInputField } from "../../../fields";

const OAVirtualDigitalAssetsForm: React.FC = () => {
  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<IVirtualDigitalAssets>();

  const getNetIncome = (purchase: string, sale: string) => {
    const gainsValue = Number(sale || 0) - Number(purchase || 0);
    setFieldValue("Gains", gainsValue);
  };

  return (
    <section className="mb-5">
      <FormField label="Enter NFT asset name" sm={4} isRequired={true}>
        <TextInputField
          name="NFTAssetName"
          value={values.NFTAssetName}
          onChange={(value) => {
            setFieldValue("NFTAssetName", value);
          }}
          onBlur={(e) => {
            handleBlur(e);
            setFieldValue("NFTAssetName", values.NFTAssetName.trim());
          }}
          isInvalid={Boolean(errors.NFTAssetName) && touched.NFTAssetName}
          errorMsg={errors.NFTAssetName}
        />
      </FormField>

      <FormField label="Date of Purchase" isRequired={true} sm={4}>
        <DateTimePicker
          name="PurchaseDate"
          placeholder="DD/MM/YYYY"
          value={values.PurchaseDate ? moment(values.PurchaseDate).toDate() : ""}
          onChange={(date) => {
            if (date) {
              const _date = UtilService.convertToStandardDateFormat(date);
              setFieldValue("PurchaseDate", _date);
            } else {
              setFieldValue("PurchaseDate", "");
            }
          }}
          onBlur={handleBlur("PurchaseDate")}
          minDate={undefined}
          maxDate={
            values?.SaleDate
              ? moment(values.SaleDate).toDate()
              : moment(CurrentFinanceYear).toDate()
          }
          isInvalid={Boolean(errors.PurchaseDate) && touched.PurchaseDate}
          errorMsg={errors.PurchaseDate}
          isClearable={true}
        />
      </FormField>

      <FormField label="Date of Sale" isRequired={true} sm={4}>
        <DateTimePicker
          name="SaleDate"
          placeholder="DD/MM/YYYY"
          value={values.SaleDate ? moment(values.SaleDate).toDate() : ""}
          onChange={(date) => {
            if (date) {
              const _date = UtilService.convertToStandardDateFormat(date);
              setFieldValue("SaleDate", _date);
            } else {
              setFieldValue("SaleDate", "");
            }
          }}
          onBlur={handleBlur("SaleDate")}
          minDate={
            values?.PurchaseDate
              ? moment(values.PurchaseDate).toDate()
              : moment(CurrentFinanceYear).toDate()
          }
          maxDate={moment(CurrentFinanceYear).toDate()}
          isInvalid={Boolean(errors.SaleDate) && touched.SaleDate}
          errorMsg={errors.SaleDate}
          isClearable={true}
        />
      </FormField>

      <FormField label="Total Purchase Price" isRequired={true} sm={4}>
        <NumericInputField
          showLeftIcon={true}
          placeholder=""
          name="TotalPurchasePrice"
          value={values.TotalPurchasePrice}
          onChange={(value) => {
            setFieldValue("TotalPurchasePrice", value);
            getNetIncome(value, values.TotalSalePrice);
          }}
          // onChange={(value) => setFieldValue("TotalPurchasePrice", value)}
          onBlur={handleBlur("TotalPurchasePrice")}
          isInvalid={Boolean(errors.TotalPurchasePrice) && touched.TotalPurchasePrice}
          errorMsg={errors.TotalPurchasePrice}
        />
      </FormField>

      <FormField label="Total Sale Price" isRequired={true} sm={4}>
        <NumericInputField
          showLeftIcon={true}
          placeholder=""
          name="TotalSalePrice"
          value={values.TotalSalePrice}
          // onChange={(value) => setFieldValue("TotalSalePrice", value)}
          onChange={(value) => {
            setFieldValue("TotalSalePrice", value);
            getNetIncome(values.TotalPurchasePrice, value);
          }}
          onBlur={handleBlur("TotalSalePrice")}
          isInvalid={Boolean(errors.TotalSalePrice) && touched.TotalSalePrice}
          errorMsg={errors.TotalSalePrice}
        />
      </FormField>

      <FormField label="Gains" sm={4}>
        <NumericInputField
          showLeftIcon={true}
          placeholder=""
          name="Gains"
          value={values.Gains}
          onChange={(value) => setFieldValue("Gains", value)}
          onBlur={handleBlur("Gains")}
          isInvalid={Boolean(errors.Gains) && touched.Gains}
          errorMsg={errors.Gains}
          isDisabled={true}
          allowNegative={true}
        />
      </FormField>
    </section>
  );
};

export default OAVirtualDigitalAssetsForm;
